import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import Loader from "../../../utils/Loader";
import { fill_action } from "../../../actions/fillList_action";
import {
  downloadReport,
  roleActionId,
  sessionExpireMessage,
  StatusActionId,
  toastError,
  tokenInavlidMessage,
} from "../../../utils/constants";
import Modal from "react-modal";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import moment from "moment";
import Header from "../../../common_components/Header";
import {
  debit_note_list_action,
  debit_note_delete_action,
  download_debitNote_action,
} from "../../../actions/accounts_action/account_debit_note_action";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
class AccountDebitNoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isAccordionExpanded: false,
      userId: "",
      OrderID: "",
      DebitNoteNo: "",
      DebitNoteDate: "",
      CompanyName: "",
      TotalAmount: "",
      StatusID: "",
      PrimaryEmailID: "",
      Status: "",
      currentPage: 1,
      debitNoteList: [],
      FromDate: "",
      ToDate: "",
      dateRange: [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ],
    };
    this.editDebitNavigate = this.editDebitNavigate.bind(this);
    this.getDebitNoteList = this.getDebitNoteList.bind(this);
    this.debitRecord = this.debitRecord.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    const { userId } = this.state;
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getDebitNoteList();
  }
  editDebitNavigate(DebitNoteID, PrimaryEmailID, RoleID) {
    this.props.navigate("/debitNoteau", {
      state: {
        DebitNoteID: DebitNoteID,
        PrimaryEmailID: PrimaryEmailID,
        RoleID: RoleID,
        isEdit:1
      },
    });
  }
  chooseDate(item) {
    this.setState({ dateRange: [item.selection] });
    console.log(item, item.selection);
    this.setState({
      FromDate:
        item.selection["startDate"] != null ? (
          moment(item.selection["startDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
      ToDate:
        item.selection["endDate"] != null ? (
          moment(item.selection["endDate"]).format("YYYY-MM-DD")
        ) : (
          <></>
        ),
    });
    console.log(
      moment(item.selection["startDate"]).format("YYYY-MM-DD"),
      moment(item.selection["endDate"]).format("YYYY-MM-DD")
    );
  }
  getDebitNoteList = async () => {
    const {
      debitNoteList,
      userId,
      DebitNoteNo,
      FromDate,
      ToDate,
      CompanyName,
      StatusID,
    } = this.state;
    this.setState({ isLoading: true });
    this.props
      .debit_note_list_action(
        DebitNoteNo,
        FromDate,
        ToDate,
        CompanyName,
        StatusID
      )
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {
          this.setState({
            debitNoteList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(debitNoteList);
    }, 500);
  };
  handleDelete(DebitNoteID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Debit Note?"
    );
    if (confirmed) {
      this.props
        .debit_note_delete_action(DebitNoteID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getDebitNoteList(); // Refresh the holiday list after deletion
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  downloadDebitNote(DebitNoteID, DebitNoteNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (DebitNoteID) {
      console.log(DebitNoteID, DebitNoteNo);
      const formattedDebitNoteNo = DebitNoteNo.replace(/[\/-]/g, "_");
      this.props
        .download_debitNote_action(userId, DebitNoteID, formattedDebitNoteNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: DebitNoteID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }
  updateItem(item) {
    console.log("updateItem : ", item);
    this.setState({ currentPage: item });
  }
  debitRecord(debitNoteList) {
    return (
      <table class="table table-bordered table-striped" id="dashboard-table">
        <thead>
          <tr>
            <th>Debit Note No</th>
            <th>Debit Note Date</th>
            <th>Company</th>
            <th>Order No</th>
            <th>Debit Note Amount</th>
            <th>Status</th>
            <th class="text-right" style={{ width: "8%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {debitNoteList.length > 0 ? (
            debitNoteList.map((data, i) => (
              <tr>
                <td>{data.DebitNoteNo}</td>
                <td>
                  {data.DebitNoteDate
                    ? moment(data.DebitNoteDate).format("DD-MM-YYYY")
                    : null}
                </td>
                <td>{data.CompanyName}</td>
                <td>{data.OrderNo ? data.OrderNo : "Not Available"}</td>
                <td>{data.TotalAmount?.toLocaleString("en-IN")}</td>
                <td>{data.Status}</td>
                <td class="text-right">
                  <a
                    title="Download PDF"
                    href="javascript:void(0);"
                    class="btn btn-sm padding_0"
                    onClick={() =>
                      this.downloadDebitNote(data.DebitNoteID, data.DebitNoteNo)
                    }
                  >
                    <i class="fa fa-file-pdf-o action_btn_table"></i>
                  </a>
                  <a
                    onClick={() =>
                      this.editDebitNavigate(
                        data.DebitNoteID,
                        data.PrimaryEmailID,
                        data.RoleID
                      )
                    }
                    href="javascript:void(0);"
                    title="Edit"
                    class="btn btn-sm"
                  >
                    <i class="fa fa-edit action_btn_table"></i>
                  </a>
                  <a
                    href="javascript:void(0);"
                    title="Delete"
                    class="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(data.DebitNoteID)}
                  >
                    <i class="fa fa-trash action_btn_table"></i>
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available.</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
  render() {
    const {
      isLoading,
      isAccordionExpanded,
      userId,
      OrderID,
      DebitNoteNo,
      DebitNoteDate,
      CompanyName,
      StatusID,
      debitNoteList,
      TotalAmount,
      Status,
      currentPage,
      FromDate,
      ToDate,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = debitNoteList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(debitNoteList.length / recordsPerPage);
    return (
      <>
        {isLoading ? (
          <Loader></Loader>
        ) : (
          <>
            <main id="main">
              <Header data={[13]} />

              <section style={{ marginTop: "115px" }}>
                <div class="container-fluid">
                  <div class="page-header">
                    <h4 class="page-title">Debit Note</h4>
                    {/* <div>
                      <a
                        href="javascript:void(0);"
                        onClick={() => this.addDebitNavigate()}
                        class="btn btn-primary btn-sm create_btn"
                      >
                        <i class="fa fa-plus"></i>{" "}
                        <span class="hidden-xs">Add</span>
                      </a>
                    </div> */}
                  </div>

                  <div class="search_accordion search_card">
                    <div class="panel-group" id="accordion">
                      <div class="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 class="panel-title">Search</h4>

                          <div class="searched_items">
                            <h5>
                              Debit Note Date :{" "}
                              <span>
                                {FromDate != "" && FromDate != "null" ? (
                                  moment(FromDate).format("DD-MM-YYYY")
                                ) : (
                                  <></>
                                )}{" "}
                                &nbsp; - &nbsp;
                                {ToDate != "" && ToDate != "null" ? (
                                  moment(ToDate).format("DD-MM-YYYY")
                                ) : (
                                  <></>
                                )}
                              </span>
                            </h5>
                            <h5>
                              Debit Note No : <span>{DebitNoteNo}</span>
                            </h5>
                            <h5>
                              Company : <span>{CompanyName}</span>
                            </h5>
                            <h5>
                              Status : <span>{Status}</span>
                            </h5>
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${
                            isAccordionExpanded ? "show" : ""
                          }`}
                        >
                          <div class="panel-body">
                            <div class="row mr_0">
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label>Debit Note Date</label>
                                  <DateRange
                                    editableDateInputs={true}
                                    onChange={(item) => this.chooseDate(item)}
                                    moveRangeOnFirstSelection={false}
                                    ranges={this.state.dateRange}
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Debit Note No</label>
                                  <input
                                    type="text"
                                    value={DebitNoteNo}
                                    onChange={(e) =>
                                      this.setState({
                                        DebitNoteNo: e.target.value,
                                      })
                                    }
                                    class="form-control search_form_control"
                                    placeholder="Debit Note No"
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Company</label>
                                  <input
                                    type="text"
                                    value={CompanyName}
                                    onChange={(e) =>
                                      this.setState({
                                        CompanyName: e.target.value,
                                      })
                                    }
                                    class="form-control search_form_control"
                                    placeholder="Enter Company"
                                  />
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="form-group">
                                  <label>Status</label>
                                  <select class="form-control">
                                    <option>Active</option>
                                    <option>Inactive</option>
                                  </select>
                                </div>
                              </div>
                              <div class="col-md-1">
                                <label>&nbsp;</label>
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => this.getDebitNoteList()}
                                  class="btn btn-primary search_btn mr-2"
                                >
                                  Search
                                </a>
                              </div>
                              <div class="col-md-1">
                                <label>&nbsp;</label>
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => window.location.reload()}
                                  class="btn btn-primary search_btn"
                                >
                                  Clear
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="custom_table">
                    <div class="hack1">
                      <div class="hack2">
                        {this.debitRecord(currentRecords)}
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </main>
            <ToastContainer />
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    fill_action,
    debit_note_list_action,
    download_debitNote_action,
    debit_note_delete_action,
  })(AccountDebitNoteList)
);
